import PropTypes from 'prop-types';
import MKTypography from 'components/MaterialKit/MKTypography';
import { datetimeFormatter } from 'utils/datetime';
import { tryGetLocalizedText } from 'utils/locales';
import { useTranslation } from 'react-i18next';

const TextSection = ({ text, variant, align, color, font_size, font_weight, is_rich_text, is_unix_timestamp, editable, onPressEdit, ...props }) => {
  const { i18n: { language } } = useTranslation();
  if (text) {
    const textContent = tryGetLocalizedText(text, language);
    const formattedFontSize = Number.isNaN(Number(font_size)) ? font_size : Number(font_size);
    const formattedText = is_unix_timestamp ? datetimeFormatter(Number.isNaN(Number(textContent)) ? textContent : Number(textContent), 'YYYY-MM-DD HH:mm:ss') : textContent || '';
    return (
      <MKTypography
        variant={variant}
        textAlign={align}
        color={color}
        fontSize={formattedFontSize}
        fontWeight={font_weight}
        {...(is_rich_text ? {
          dangerouslySetInnerHTML: {
            __html: is_unix_timestamp ? formattedText : textContent || '',
          },
        } : {
          children: is_unix_timestamp ? formattedText : textContent || '',
        })}
        {...props}
      />
    );
  }
};

TextSection.propTypes = {
  text: PropTypes.string,
  variant: PropTypes.string,
  align: PropTypes.string,
  color: PropTypes.string,
  font_size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  font_weight: PropTypes.string,
  is_rich_text: PropTypes.bool,
  is_unix_timestamp: PropTypes.bool,
  editable: PropTypes.bool,
  onPressEdit: PropTypes.func,
};

export default TextSection;
